<template>
    <div>
        <div v-if="loading" class="container">
            <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
        </div>
        <div v-if="!loading" class="container">
            <div class="d-flex flex-column align-items-center">
                <h4>Misc Expense Report</h4>
                <h2 style="font-weight: bold">{{expenseReport.reportName}}</h2>
                <p>Generated at {{currentDate | formatDatetime}}</p>
                <p>{{expenseReportStatusTypeName}}</p>
            </div>
            <div class="mb-4" v-for="item,itemIndex in expenseReport.miscReportItems">
                <h4 style="font-weight:bold">Item {{itemIndex + 1}}</h4>
                <div class="row">
                    <div class="form-group col-sm-6">
                        <label>Purchase Date:</label>
                        <p class="form-control-plaintext">{{item.itemDate | formatDate}}</p>
                    </div>
                    <div class="form-group col-sm-6">
                        <label>Vendor:</label>
                        <p class="form-control-plaintext">{{item.vendor}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-6">
                        <label> Materials and Supplies:</label>
                        <p class="form-control-plaintext">{{getLookupValue(reportItemTypes, 'displayName', item.miscReportItemTypeId)}}</p>
                    </div>
                    <div class="form-group col-sm-6">
                        <label>Other Description:</label>
                        <p class="form-control-plaintext">{{item.miscReportItemTypeComment}}</p>
                    </div>
                </div>
                <div class="form-group">
                    <label>Reason:</label>
                    <p class="form-control-plaintext">{{item.reason}}</p>
                </div>
                <div v-for="alloc in item.projectAmountAllocations">
                    <div class="row">
                        <div class="form-group col-sm-6">
                            <label>Amount:</label>
                            <p class="form-control-plaintext">{{alloc.allocationValue | currency}}</p>
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Project:</label>
                            <p class="form-control-plaintext">{{getLookupValue(projects, 'projectName', alloc.projectId)}}</p>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Sub-total:</label>
                    <p class="form-control-plaintext">{{subTotalMiscReportItemAmount(item) | currency}}</p>
                </div>
            </div>
            <div class="form-group">
                <h4 style="font-weight:bold">Total</h4>
                <p class="form-control-plaintext">{{totalMiscReportItemAmount | currency}}</p>
            </div>
        </div>
    </div>
</template>


<style scoped>
    div {
        font-size: 1.2rem;
    }

    .form-control-plaintext {
        font-weight: bold;
    }
</style>

<script>
    import MiscExpenseReportService from '@/services/MiscExpenseReportService'
    import TripProfileService from '@/services/TripProfileService'
    import ProjectService from '@/services/ProjectService'

    export default {
        name: 'misc-expense-report-print',
        components: {
        },
        async created() {
            this.currentDate = new Date();
            if (this.$route.params.erid) {
                this.loading = true;
                this.expenseReportID = this.$route.params.erid;
                this.expenseReport = await MiscExpenseReportService.get(this.expenseReportID);
                const expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                this.expenseReportStatusTypeName = expenseReportStatus.expenseReportStatusTypeName;
                this.reportItemTypes = await MiscExpenseReportService.getItemTypes();
                this.projects = await ProjectService.getProjects();

            }

            this.loading = false;
        },
        data: function () {
            return {
                currentDate: null,
                loading: false,
                expenseReportStatusTypeName: null,
                expenseReportID: null,
                expenseReport: null,
                reportItemTypes: [],
                projects: []
            }
        },
        computed: {
            totalMiscReportItemAmount() {
                let total = 0;
                if (this.expenseReport != null && this.expenseReport.miscReportItems != null && this.expenseReport.miscReportItems.length > 0) {
                    this.expenseReport.miscReportItems.forEach(function (item) { total = Number(total) + Number(item.amount) })
                }

                return total;
            }
        },
        methods: {
            subTotalMiscReportItemAmount(item) {
                let total = 0;
                if (item != null && item.projectAmountAllocations != null && item.projectAmountAllocations.length > 0) {
                    item.projectAmountAllocations.forEach(function (paaItem) {
                        total = Number(total) + Number(paaItem.allocationValue)
                    })
                }
                item.amount = total;
                return total;
            },
            getLookupValue(list, nameProperty, id) {
                const item = list.find((i) => i.id == id)
                if (item) {
                    return item[nameProperty];
                }
            }
        }
    }

</script>